import FilterConstants from '../../filter-constants';
import BaseOptimization from './base-optimization';

export default class RecommendedSpecificOptimization extends BaseOptimization {
  name = FilterConstants.optimizationType.recommendedSpecific;

  getOpAmpRequirementSpecValues(stopbandFrequency) {
    var base = this; // to specify which one comes from the base class;
    var specs = {
      fMultiplier: 50, //bigger is more strict:  used for highpass
      allowedError: 0.05, //smaller is more strict: used lowpass and bandpass
      rOutFreqMultiplier: 3, //rout shouldn't come into play until 5x stopband
      inductorMultiplier: 5,
      dcOutputVoltageFromIBias: 0.2,
      stopbandFrequency: stopbandFrequency,
    };

    specs.f = stopbandFrequency * specs.rOutFreqMultiplier;

    var result = base.adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

    return result;
  }

  determineCapacitorValue(stageFp) {
    var startingCapacitor = null;
    switch (true) {
      //fp is below 15.9Hz
      case stageFp < 15.9:
        // 1/(2*PI*fp* 100kohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 100000);
        break;

      //fp is 15.9 Hz to 159Hz
      case stageFp >= 15.9 && stageFp <= 159:
        //100 nF
        startingCapacitor = 100 * 1e-9;
        break;

      //fp is 159Hz to 15.9kHz
      case stageFp >= 159 && stageFp <= 15900:
        //1/(2*PI*fp* 10kohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 10000);
        break;

      //fp is 15.9kHz to 159 kHz
      case stageFp >= 15900 && stageFp <= 159000:
        //1 nF
        startingCapacitor = 1 * 1e-9;
        break;

      //fp is above 159kHz
      case stageFp > 159000:
        //1/(2*PI*fp*1 kohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 1000);
        break;
    }

    return startingCapacitor;
  }

  determineStartingR3R4Value(stageFp) {
    var base = this; // to specify which one comes from the base class;
    var rMin = Math.sqrt(100000);
    var rMax = 1000000;
    var result = base.processR3R4Value(stageFp, rMin, rMax);
    return result;
  }
}
